import { CustomPDFReportType } from './enums/custom-pdf-report-type.enum';
import { CustomPDFReportNumRequiredSecurities } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-required-num-securities.enum';
export const CREATE_REPORT_TYPES = [
    CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW,
    CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON,
    CustomPDFReportType.MULTI_SECURITY_COMPARISON,
];
export const REPORT_TYPE_LABELS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: '1 Security',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: '2 Securities',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: '3+ Securities',
};
export const REPORT_TYPE_LOGOS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'icon-template-overview-color',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'icon-template-comp-color',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'icon-template-multicomp-color',
};
export const REPORT_TYPE_DESCRIPTIONS = {
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'An overview report of a single security',
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'A comparison report of two securities',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'A comparison report of 3-7 securities',
};
// Generateable Legacy Report Types
export const LEGACY_REPORT_TYPES = {
    TEARSHEET: 'legacy_tearsheets',
    Y_RATING: 'legacy_y_rating',
};
// Security Level Options
export const INDIVIDUAL_LEVEL = 'Individual Level';
export const SECURITY_A = 'Security A';
export const CUSTOM = 'Custom';
export const DEFAULT_SECURITY_LEVEL = 10000;
// As Of Date options
export const AS_OF_DATE_LATEST = 'latest';
export const AS_OF_DATE_MONTH_END = 'month_end';
export const AS_OF_DATE_QUARTER_END = 'quarter_end';
export const DATA_SOURCE_OPTIONS = [
    {
        label: 'Default',
        value: 'default',
    },
    {
        label: 'Legacy',
        value: 'legacy',
    },
];
export const AS_OF_DATE_DROPDOWN_CONFIG = {
    list: [
        {
            disabled: false,
            label: 'Latest',
            type: 'option',
            value: AS_OF_DATE_LATEST,
        },
        {
            disabled: false,
            label: 'Month End',
            type: 'option',
            value: AS_OF_DATE_MONTH_END,
        },
        {
            disabled: false,
            label: 'Quarter End',
            type: 'option',
            value: AS_OF_DATE_QUARTER_END,
        },
    ],
};
export const DEFAULT_PERFORMANCE_DISCLOSURE_FOOTNOTE = 'The performance data quoted presents past performance; past performance does not guarantee future results; ' +
    'the investment return and principal value of an investment will fluctuate; an investor’s shares, when ' +
    'redeemed, may be worth more or less than their original cost; current performance may be lower or higher ' +
    'than the performance data quoted. The most recent month end performance data can be accessed at ' +
    'https://go.ycharts.com/fund_contact_info. (See the Standardized Returns section of this report for ' +
    'standardized returns information).';
// PDF Report Preview Constants
export const PDF_PREVIEW_PARAMS = {
    contact_email: 'you@yourcompany.com',
    contact_url: 'www.yourcompany.com',
    contact_phone: '123-456-7890',
    organization: 'Your Company',
    prepared_by: 'Your Name',
    prepared_for: 'Your Client',
    report_title: 'Your Report Title',
    as_of_date_option: 'latest',
};
export const PDF_PREVIEW_SECURITIES = {
    [CustomPDFReportNumRequiredSecurities.ONE]: {
        security_ids: ['SPY'],
    },
    [CustomPDFReportNumRequiredSecurities.TWO]: {
        security_ids: ['SPY', 'QQQ'],
    },
    [CustomPDFReportNumRequiredSecurities.THREE_PLUS]: {
        security_ids: ['SPY', 'QQQ', 'M:VFIAX'],
    },
};
